import { Injectable } from '@angular/core';
import { Headers, RequestOptions, URLSearchParams, Http } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/observable/empty';

@Injectable()
export class SalesInvoiceService {
    private headers = new Headers({ 'Content-Type': 'application/x-www-form-urlencoded', 'Accept': 'q=0.8;application/json;q=0.9' });
    private Url = 'api/salesInvoice'; 
    private Url2 = 'api/damageInvoice'; 
    private Url5 = 'api/oliveInvoice';
    private Url6 = 'api/jobInvoice';
    private Url4 = 'api/partyDesignDetail';
    private autoUrl = 'api/autoNumber';
    private Url3 = 'api/partyOrderDetails';
     private phase1Url = 'api/phase1';
    private comboUrl = 'api/combo';  // URL to web api
    private designUrl = 'api/designStockEntry';
    private convertTypes = 'api/convertShirtTypes';
    private printUrl = 'api/print';
    private combo2Url = 'api/combo2';
     private tallyUrl = 'api/tallyExcel'; 


    constructor(private http: Http) { }

    private extractData(res: any) {
        let body = res.json();
        return body || [];
    }

    private htmlData(res: any) {
        let body = res._body;
        return body || [];
    }

    salesInvoiceList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/salesInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    // Trims sales invoice list

    trimsSalesInvoiceList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/trimsSalesInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }


    textileSalesInvList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/textileSalesInvList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    checkTextilecode(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/checkTextilecode`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    damageInvoiceList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url2}/damageInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
  oliveInvoiceList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url5}/oliveInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    jobInvoiceList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url6}/jobInvoiceList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getAutoBillNumber(partyData: any): Promise<any[]> {
        const url = `${this.Url2}/getAutoBillNumber`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getAutoNumberBill(partyData: any): Promise<any[]> {
        const url = `${this.Url5}/getAutoNumberBill`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
     getAutoBill(partyData: any): Promise<any[]> {
        const url = `${this.Url6}/getAutoBill`;
         return this.http
             .post(url, $.param(partyData), { headers: this.headers })
             .toPromise()
             .then(res => res.json() as any)
             .catch(this.handleError);
     }
    saveEstimateVerify(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/saveEstimateVerify`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
        convertDistributorInv(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/convertDistributorInv`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    
    saveEstimateVerifyBundle(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/saveEstimateVerifyBundle`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getAutoNumber(partyData: any): Promise<any[]> {
    const url = `${this.autoUrl}/getAutoNumber`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSalesParty(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getSalesParty`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    getSeason(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getSeason`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getCurrentSeason(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getCurrentSeason`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    checkBarcode(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.designUrl}/checkBarcode`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    checkConvertShirtTypesBarcode(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.convertTypes}/checkConvertShirtTypesBarcode`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    partyDesignDetails(partyData: any): Promise<any> {	
        const url = `${this.Url4}/partyDesignDetails`;	
        return this.http	
            .post(url, $.param(partyData), { headers: this.headers })	
            .toPromise()	
            .then(res => res.json() as any)	
            .catch(this.handleError);	
    }	
    selectedFinSeason(partyData: any): Promise<any> {	
        const url = `${this.Url4}/selectedFinSeason`;	
        return this.http	
            .post(url, $.param(partyData), { headers: this.headers })	
            .toPromise()	
            .then(res => res.json() as any)	
            .catch(this.handleError);	
    }
    getDeliveryPartyCombo(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.Url}/getDeliveryPartyCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

    saveUpdateSalesInvoice(partyData: any): Promise<any> {
        const url = `${this.Url}/saveUpdateSalesInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    // special sales invoice 
    saveUpdateSpecialInvoice(partyData: any): Promise<any> {
        const url = `${this.Url}/saveUpdateSpecialInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    // Trims sales invoice 
    saveUpdateTrimsInvoice(partyData: any): Promise<any> {
        const url = `${this.Url}/saveUpdateTrimsInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    saveUpdateTextileInvoice(partyData: any): Promise<any> {
        const url = `${this.Url}/saveUpdateTextileInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveConvertType(partyData: any): Promise<any> {
        const url = `${this.convertTypes}/saveConvertType`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
   
    loadupdatelist(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.convertTypes}/loadupdatelist`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    getShirtTypeupdateList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.convertTypes}/getShirtTypeupdateList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    partyOrderDetails(partyData: any): Promise<any> {
        const url = `${this.Url3}/partyOrderDetails`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

      partyPendingOrderDetails(partyData: any): Promise<any> {
        const url = `${this.phase1Url}/partyPendingOrderDetails`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
       openingStockreport(partyData: any): Promise<any> {
        const url = `${this.phase1Url}/openingStockreport`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

       bagBeltstockReport(partyData: any): Promise<any> {
        const url = `${this.phase1Url}/bagBeltstockReport`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
      rgrnBagpendingReport(partyData: any): Promise<any> {
        const url = `${this.phase1Url}/rgrnBagpendingReport`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
   rackPendingreport(partyData: any): Promise<any> {
        const url = `${this.phase1Url}/rackPendingreport`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    upcomingStock(partyData: any): Promise<any> {
        const url = `${this.Url3}/upcomingStock`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveUpdateDamageInvoice(partyData: any): Promise<any> {
        const url = `${this.Url2}/saveUpdateDamageInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveUpdateOliveInvoice(partyData: any): Promise<any> {
        const url = `${this.Url5}/saveUpdateOliveInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    saveUpdateJobInvoice(partyData: any): Promise<any> {
        const url = `${this.Url6}/saveUpdateJobInvoice`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    gettextileInvoiceDet(partyData: any): Promise<any> {
        const url = `${this.Url}/gettextileInvoiceDet`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSiEntryGridShirtSizeDet(partyData: any): Promise<any> {
        const url = `${this.Url}/getSiEntryGridShirtSizeDet`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    // Trims sales invoice det List
    getTrimsDetList(partyData: any): Promise<any> {
        const url = `${this.Url}/getTrimsDetList`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    getBarcodeOpenOrder(partyData: any): Promise<any> {
        const url = `${this.Url}/getBarcodeOpenOrder`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getPartyOrderNumber(partyData: any): Promise<any> {
        const url = `${this.Url}/getPartyOrderNumber`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    onSelectPartyNamePartyOrder(partyData: any): Promise<any> {
        const url = `${this.Url3}/onSelectPartyNamePartyOrder`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    boxprintModal(partyData: any): Promise<any> {
        const url = `${this.Url}/boxprintModal`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    wholesaleInvConvertion(partyData: any): Promise<any> {
        const url = `${this.Url}/wholesaleInvConvertion`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    checkInvno(partyData: any): Promise<any> {
        const url = `${this.Url}/checkInvno`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    
    getSiEntryGridShirtSizeDetDam(partyData: any): Promise<any> {
        const url = `${this.Url2}/getSiEntryGridShirtSizeDetDam`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSiEntryGridShirtSizeDetOlive(partyData: any): Promise<any> {
        const url = `${this.Url5}/getSiEntryGridShirtSizeDetOlive`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    getSiEntryGridShirtSizeDetJob(partyData: any): Promise<any> {
        const url = `${this.Url6}/getSiEntryGridShirtSizeDetJob`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    delete(userData: any): Promise<any> {
        const url = `${this.Url}/delete`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    salesInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/salesInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    retailInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/retailInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
     convertExcel(userData: any): Promise<any> {
        const url = `${this.tallyUrl}/convertExcel`;
        return this.http
            .post(url, $.param(userData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    textileInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/textileInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    damageInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/damageInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    oliveInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/oliveInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    jobInvoicePrint(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.printUrl}/jobInvoicePrint`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.htmlData)
            .catch(this.handleError);
    }
    getFinYearList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getFinYearList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
     getInvoiceCombo(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }

        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });

        const url = `${this.comboUrl}/getInvoiceCombo`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    onSavedesign(partyData: any): Promise<any> {
        const url = `${this.Url4}/onSave`;
        return this.http
            .post(url, $.param(partyData), { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }
    designwiseList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });
        const url = `${this.Url4}/designwiseList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }
    designwiseViewList(query: any): Promise<any[]> {
        let params: URLSearchParams = new URLSearchParams();
        for (let key in query) {
            params.set(key.toString(), query[key]);
        }
        let options = new RequestOptions({
            headers: this.headers,
            search: params
        });
        const url = `${this.Url4}/designwiseViewList`;
        return this.http.get(url, options)
            .toPromise()
            .then(this.extractData)
            .catch(this.handleError);
    }

     finyearCombo(): Promise<any> {
        const url = `${this.combo2Url}/finyearCombo`;
        return this.http
            .get(url, { headers: this.headers })
            .toPromise()
            .then(res => res.json() as any)
            .catch(this.handleError);
    }

    private handleError(error: any): Promise<any> {
        //console.error('An error occurred', error); // for demo purposes only
        return Promise.reject(error.message || error);
    }
}


// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/services/salesinvoice.service.ts